import React from "react";
import { Flipper, Flipped } from "react-flip-toolkit";
import { Box, Typography } from "@mui/material";

const FlipClock = ({ city, time }) => {
  const [hours, minutes, amPm] = time.split(/[: ]/);

  return (
    <Box sx={{ textAlign: "center", mt: 1 }}>
      <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
        {city}
      </Typography>
      <Flipper flipKey={time} spring="stiff">
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "3px" }}>
          <FlipUnit number={hours[0]} />
          <FlipUnit number={hours[1]} />
          <Typography sx={{ fontSize: "20px", fontWeight: "bold", color: "black", mx: "2px" }}>:</Typography>
          <FlipUnit number={minutes[0]} />
          <FlipUnit number={minutes[1]} />
          <Typography sx={{ fontSize: "14px", fontWeight: "bold", ml: 1 }}>{amPm}</Typography>
        </Box>
      </Flipper>
    </Box>
  );
};

const FlipUnit = ({ number }) => {
  return (
    <Flipped flipId={number}>
      <Box
        sx={{
          position: "relative",
          width: "28px",
          height: "42px",
          backgroundColor: "black",
          color: "white",
          fontSize: "22px",
          fontWeight: "bold",
          textAlign: "center",
          lineHeight: "42px",
          borderRadius: "6px",
          overflow: "hidden",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {number}
      </Box>
    </Flipped>
  );
};

export default FlipClock;